import $ from 'jquery';
import jQuery from 'jquery';
import availModal from './modal';
import Swiper, {Pagination, Navigation, Lazy, Keyboard, Autoplay} from 'swiper';
import moment from 'moment/locale/de';
import Chart from 'chart.js';
import ekkoLightbox from './lightbox';
import table from './basictable';

// Loading ext based js files only when page contains the plugin
if ($('.tx-femanager').length >= 1) {
    $.getScript( "../../../typo3conf/ext/femanager/Resources/Public/JavaScript/Validation.min.js");
    $.getScript( "../../../typo3conf/ext/femanager/Resources/Public/JavaScript/Femanager.min.js");
}
//Hamburger menu open/close state
$(".hamburger-menu").click(function(){
    $(this).toggleClass("activated");
    $(".menu").slideToggle();
});

//Faq closing/opening
$(".accordion-item .icon").click(function(){
    $(this).toggleClass("activated");
    $(this).parent().find('.card-body').toggleClass("activated");
});

// Initialize swiper for big slider
Swiper.use([Pagination, Lazy, Keyboard, Autoplay]);
let Slider = new Swiper('.swiper-container', {
    autoplay: {
        delay: 5000,
    },
    speed:1000,
    direction: 'horizontal',
    loop: true,
    keyboard: {
        enabled: true,
    },
    pagination: {
        el: '.swiper-pagination',
    },
    preloadImages: false,
    lazy: true,
});

//Fix issue with anchor links
$(".slider-description .red-btn-border").click(function(){
    setTimeout(function() {
        window.scrollBy({
            top: -150,
            left: 0,
            behavior: 'auto'
        });
    }, 10);
});

// Initialize swiper for file slider
Swiper.use([Pagination, Navigation, Lazy, Keyboard]);
let SliderFiles = new Swiper('.swiper-container-files', {
    direction: 'horizontal',
    loop: false,
    keyboard: {
        enabled: true,
    },
    pagination: {
        el: '.swiper-pagination-files',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
    },
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    preloadImages: false,
    lazy: true,
    observer: true,
    observeParents: true
});

$(".fund-filter .charts-view-menu .menu").click(function(e){
    $('.charts-view-menu img').toggleClass("active");
    $('.charts-wrapper-filter').hide();
    $('.fondsfinder-compare-table table').show();
    e.stopImmediatePropagation();
});

$(".fund-filter .charts-view-menu .grid").click(function(e){
    $('.charts-view-menu img').toggleClass("active");
    $('.fondsfinder-compare-table table').hide();
    $('.charts-wrapper-filter').show();
    e.stopImmediatePropagation();
});

//Change chart view menu/grid
$(".charts-view-menu .menu").click(function(){
    $('.charts-view-menu img').toggleClass("active");
    $('.charts-wrapper').toggleClass("menu-view");
});

$(".charts-view-menu .grid").click(function(){
    $('.charts-view-menu img').toggleClass("active");
    $('.charts-wrapper').toggleClass("menu-view");
});

//Tab section opening/closing
$(".tabsection-container .nav-tabs li").click(function(){

    //Prevent conflict when there are multiple tabsections on one page
    let tabSection = $(this).attr("data-tabsection");

    $('.'+tabSection+' .nav-tabs li').removeClass('active');
    $(this).addClass('active');

    let activeTab = 'tab' + $(this).attr("data-tab");
    $('.'+tabSection+' .tab-content').removeClass('active');
    $('.tabsection-container').find(`[data-tab='${activeTab}']`).addClass('active');
});

//Sticky menu
let navigationHeight = $('.main-header').height() + 40;
window.addEventListener('scroll', function(e) {
    if (window.pageYOffset > 120) {
        $('.main-header').addClass('sticky');
        $('.hide-on-sticky').addClass('hidden');
        $('main').css('margin-top',navigationHeight+'px');

    } else {
        $('.main-header').removeClass('sticky');
        $('.hide-on-sticky').removeClass('hidden');
        $('main').css('margin-top',0+'px');
    }
})

//Additional filters toggle for fonds filter
$(".fondsfinder-filter .collapse div").click(function(){
    $('.additional-filter').toggleClass("show");
    $(".fondsfinder-filter .collapse img").toggleClass("rotate");
    $(".fondsfinder-filter .collapse").toggleClass("open");
    if ($(".fondsfinder-filter .collapse").hasClass("open")) {
        $(".fondsfinder-filter .open div span").text('Weniger Suchkriterien');
    } else {
        $(".fondsfinder-filter .collapse div span").text('Mehr Suchkriterien');
    }
});

function fundComparisonSelection(clickedElement = null) {
    let fundId = clickedElement.attr("data-id"),
        iconPath = clickedElement.attr("data-icon-path"),
        fundTitle = null;

    if (clickedElement.closest("tr").length > 0) {
        fundTitle = clickedElement.closest("tr").find("a").html();
    } else {
        fundTitle = clickedElement.parent().siblings('.title').html();
    }

    let fundDetails = { 'fundId': fundId, 'iconPath': iconPath, 'fundTitle': fundTitle };

    if ($('#fund1').val() == 0) {
        $('#fund1').val(fundId);
        localStorage.setItem('fund1', JSON.stringify(fundDetails));
        updateISINValues();
        //Change icon
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).next().toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).next().toggleClass("hidden");

        //Add box
        $(".selected-funds .header").after(`<div class='selected-fund' data-id='${fundId}' data-storage-id="fund1">${fundTitle}<div class='close'><img alt='open' src='${iconPath}Images/close-background.svg' width='25' height='25'></div></div>`);
    } else if ($('#fund2').val() == 0) {
        $('#fund2').val(fundId);
        localStorage.setItem('fund2', JSON.stringify(fundDetails));
        updateISINValues();
        //Change icon
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).next().toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).next().toggleClass("hidden");

        //Add box
        $(".selected-funds .header").after(`<div class='selected-fund' data-id='${fundId}' data-storage-id="fund2">${fundTitle}<div class='close'><img alt='open' src='${iconPath}Images/close-background.svg' width='25' height='25'></div></div>`);
    } else if ($('#fund3').val() == 0) {
        $('#fund3').val(fundId);
        localStorage.setItem('fund3', JSON.stringify(fundDetails));
        updateISINValues();
        //Change icon
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).next().toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${fundId}]`).next().toggleClass("hidden");

        //Add box
        $(".selected-funds .header").after(`<div class='selected-fund' data-id='${fundId}' data-storage-id="fund3">${fundTitle}<div class='close'><img alt='open' src='${iconPath}Images/close-background.svg' width='25' height='25'></div></div>`);
    } else {
        alert("You can select maximum of 3 funds!");
    }

}

let pickedFunds = [];
//Fonds compare add/remove
$(".fondsfinder-compare-table .add").click(function(){
    fundComparisonSelection($(this));

    //Clear current fond
    $(".selected-fund .close").on('click',function(){
        let removedFundId = $(this).closest(".selected-fund").attr("data-id");
        let storageFundId = $(this).closest(".selected-fund").attr("data-storage-id");
        let fundsId = $(`.fond-ids input[value=${removedFundId}]`).attr("id");
        localStorage.removeItem(storageFundId);
        $(`#${storageFundId}`).val(0);

        $(`.chart-container .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${removedFundId}]`).next().toggleClass("hidden");
        $(`.fondsfinder-compare-table .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.fondsfinder-compare-table .add[data-id=${removedFundId}]`).next().toggleClass("hidden");

        $(`#action-added-${removedFundId}`).addClass("hidden");
        $(`#action-add-${removedFundId}`).removeClass("hidden");

        $(`.chart-container .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${removedFundId}]`).next().toggleClass("hidden");
        $(this).closest(".selected-fund").remove();

        updateISINValues();
    });

});

$(".dynamic-buttons .add").click(function(){
    fundComparisonSelection($(this));

    if ($("#fund-list .selected-funds .selected-fund").length == 1 && $("#fund-list .selected-funds").hasClass("d-none")){
        $("#fund-list .selected-funds").toggleClass("d-none");
    }

    //Clear current fond
    $(".selected-fund .close").on('click',function(){
        let removedFundId = $(this).closest(".selected-fund").attr("data-id");
        let storageFundId = $(this).closest(".selected-fund").attr("data-storage-id");
        let fundsId = $(`.fond-ids input[value=${removedFundId}]`).attr("id");
        localStorage.removeItem(storageFundId);
        $(`#${storageFundId}`).val(0);

        $(`.dynamic-buttons .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.dynamic-buttons .add[data-id=${removedFundId}]`).next().toggleClass("hidden");

        $(`#action-added-${removedFundId}`).addClass("hidden");
        $(`#action-add-${removedFundId}`).removeClass("hidden");

        $(this).closest(".selected-fund").remove();

        if ($("#fund-list .selected-funds .selected-fund").length < 1){
            $("#fund-list .selected-funds").toggleClass("d-none");
        }

        updateISINValues();
    });

});

//Clear all fonds
$(".selected-funds .close-all").click(function(){
    $('#fund1').val(0);
    $('#fund2').val(0);
    $('#fund3').val(0);
    //Remove from localstorage.
    localStorage.removeItem('fund1');
    localStorage.removeItem('fund2');
    localStorage.removeItem('fund3');
    $('.selected-fund').remove();
    $(".fondsfinder-compare-table .add").removeClass("hidden");
    $(".fondsfinder-compare-table .added").addClass("hidden");
    $(".chart-container .add").removeClass("hidden");
    $(".chart-container .added").addClass("hidden");

    if($('#fund-list')) {
        $("#fund-list .selected-funds").toggleClass("d-none");
    }

});

// Deals the scroll when anchor tags directly accessed without a click event
$(document).ready(function() {
    let fundDetails1 = localStorage.getItem('fund1');
    if(fundDetails1 != null){
        let funInfos1 = JSON.parse(fundDetails1);
        let fundId1 = funInfos1.fundId,
        fundTitle1 = funInfos1.fundTitle,
        iconPath1 = funInfos1.iconPath;
        renderComparisonItems('fund1',fundId1,fundTitle1,iconPath1);
    }

    let fundDetails2 = localStorage.getItem('fund2');
    if(fundDetails2 != null ){
        let funInfos2 = JSON.parse(fundDetails2);
        let fundId2 = funInfos2.fundId,
        fundTitle2 = funInfos2.fundTitle,
        iconPath2 = funInfos2.iconPath;
        renderComparisonItems('fund2',fundId2,fundTitle2,iconPath2);
    }

    let fundDetails3 = localStorage.getItem('fund3');
    if(fundDetails3 != null){
        let funInfos3 = JSON.parse(fundDetails3);
        let fundId3 = funInfos3.fundId,
        fundTitle3 = funInfos3.fundTitle,
        iconPath3 = funInfos3.iconPath;
        renderComparisonItems('fund3',fundId3,fundTitle3,iconPath3);
    }

    if($('#fund-list')) {
        if(fundDetails1 || fundDetails2 || fundDetails3){
            $("#fund-list .selected-funds").toggleClass("d-none");
        }
    }

});

//Remove column from comparison table
$(".comparison-table .close").click(function(){
    let columnToRemove = $(this).parent().index()+1;
    $(`.comparison-table table tr td:nth-child(${columnToRemove})`).remove();
    $(`.comparison-table table tr th:nth-child(${columnToRemove})`).remove();
});

//Set title to Ekomi logo
setTimeout(function() {
    $('.ekomi-rating-seal img').prop('title', 'eKomi-Bewertungen');
}, 2000);

//Sample chart configuration
let charts = document.getElementsByClassName('chart-canvas');

for (const [key, value] of Object.entries(charts)) {
    loadCharts(value, key);
}

function loadCharts(item, index, clickedElement = null) {

    let jsonGraphData;
    if (clickedElement) {
        let settings = {
            dataType: 'jsonp'
        };

        $.ajax({
            dataType: 'jsonp',
            url: clickedElement,
            success: function(response){
                jsonGraphData = response.data;
                buildChart(jsonGraphData, item);
            }
        });
    } else {
        jsonGraphData = JSON.parse(item.getAttribute('data-graph'));
        buildChart(jsonGraphData, item);
    }
}

function buildChart(jsonGraphData, item) {

    let graphDataOne = [],
        graphDataTwo = [],
        labelOne = '',
        labelTwo = '',
        mainColorScheme = item.getAttribute('data-main-color-theme'),
        disableLegend = item.hasAttribute('data-disbale-legend') &&  item.getAttribute('data-disbale-legend') == '1' ? false :  true;

    let chartData = [];

    if (jsonGraphData.length <= 1) {
        // For funds which doesn't have graph data
        // (They only have peergroup data)
        for(let i=0; i<jsonGraphData[0]['ts'].length; i++){
            labelTwo = jsonGraphData[0]['meta']['name'];
            graphDataTwo.push({
                x: new Date( jsonGraphData[0]['ts'][i][0] ),
                y: jsonGraphData[0]['ts'][i][1]
            });
        }
    } else {
        // Populating the two data arrays from the API data
        // The graph is meant to display two graphs all time
        for(let i=0; i<jsonGraphData[0]['ts'].length; i++){
            labelOne = jsonGraphData[0]['meta']['name'];
            graphDataOne.push({
                x: new Date( jsonGraphData[0]['ts'][i][0] ),
                y: jsonGraphData[0]['ts'][i][1]
            });
        }

        for(let i=0; i<jsonGraphData[1]['ts'].length; i++){
            labelTwo = jsonGraphData[1]['meta']['name'];
            graphDataTwo.push({
                x: new Date( jsonGraphData[1]['ts'][i][0] ),
                y: jsonGraphData[1]['ts'][i][1]
            });
        }
    }

    if (document.querySelector('.chart-canvas') == null) {
        if(window.chartData != undefined) {
            window.chartData.destroy();
        }
        window.chartData = new Chart(item.getContext('2d'), {
            type: 'line',
            data: {
                datasets: [
                    {
                        label: labelOne,
                        data: graphDataOne,
                        borderColor: mainColorScheme,
                        fill: false,
                        borderWidth: '1',
                        lineTension: '0',
                        pointRadius: '0',
                    },
                    {
                        label: labelTwo,
                        data: graphDataTwo,
                        borderColor: '#dcdadb',
                        fill: false,
                        borderWidth: '1',
                        lineTension: '0',
                        pointRadius: '0',
                    }
                ]
            },
            options: {
                scales: {
                    yAxes: [{
                        display: false,
                        gridLines: {
                            display: false
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        distribution: 'series',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            autoSkip: true,
                            autoSkipPadding: 9999,
                            maxRotation: 0,
                        }
                    }],
                }
            }
        });
    } else {
        chartData = new Chart(item.getContext('2d'), {
            type: 'line',
            data: {
                datasets: (disableLegend != false) ? [
                    {
                        label: labelOne,
                        data: graphDataOne,
                        borderColor: mainColorScheme,
                        fill: false,
                        borderWidth: '1',
                        lineTension: '0',
                        pointRadius: '0',
                    },
                    {
                        label: labelTwo,
                        data: graphDataTwo,
                        borderColor: '#dcdadb',
                        fill: false,
                        borderWidth: '1',
                        lineTension: '0',
                        pointRadius: '0',
                    }
                ]: [
                    {
                        label: labelOne,
                        data: graphDataOne,
                        borderColor: mainColorScheme,
                        fill: false,
                        borderWidth: '1',
                        lineTension: '0',
                        pointRadius: '0',
                    }
                ]
            },
            options: {
                scales: {
                    yAxes: [{
                        display: false,
                        gridLines: {
                            display: false
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        distribution: 'series',
                        gridLines: {
                            drawOnChartArea: false
                        },
                        ticks: {
                            autoSkip: true,
                            autoSkipPadding: 9999,
                            maxRotation: 0,
                        }
                    }],
                },
                legend: {
                    display: disableLegend
                }
            }
        });
    }
}

//Filter for depot-opening forms
//First level menu
let firstLevelSelection = 0;
let secondLevelSelection = 0;
let thirdLevelSelection = 0;

$('.opening-depot-filter .level-one input').change(function() {
    $('.opening-depot-filter input').prop('checked', false);
    $(this).prop('checked', true);
    $('.opening-depot-filter .title').removeClass('hidden');

    if($(this).attr('id') == "ebs") {
        $('.opening-depot-filter .level-two').removeClass('hidden');
        $('.opening-depot-filter .level-three').addClass('hidden');
    } else {
        $('.opening-depot-filter .level-two').addClass('hidden');
        $('.opening-depot-filter .level-three').removeClass('hidden');
        secondLevelSelection = 0;
    }

    firstLevelSelection = $(this).attr('id');
    $('.opening-depot-form').hide();
});

//Second level filter
$('.opening-depot-filter .level-two input').change(function() {
    $('.opening-depot-filter .level-two input').prop('checked', false);
    $('.opening-depot-filter .level-three input').prop('checked', false);
    $(this).prop('checked', true);

    $('.opening-depot-filter .level-three').removeClass('hidden');

    if($(this).attr('id') == "vld") {
        $('.opening-depot-filter .level-three.gmd').addClass('hidden');
    }

    secondLevelSelection = $(this).attr('id');
    $('.opening-depot-form').hide();
});

//Third level filter
$('.opening-depot-filter .level-three input').change(function() {
    $('.opening-depot-filter .level-three input').prop('checked', false);
    $(this).prop('checked', true);

    thirdLevelSelection = $(this).attr('id');
    $('.opening-depot-form').hide();

    if(secondLevelSelection != 0) {
        $('.' + firstLevelSelection + '-' + secondLevelSelection + '-' + thirdLevelSelection).show();
    } else {
        $('.' + firstLevelSelection + '-' + thirdLevelSelection).show();
    }
});


//Fonds detail page graphs
let detailCharts = document.getElementsByClassName('chart-canvas-wertentwicklung');

for (const [key, value] of Object.entries(detailCharts)) {
    loadCharts(value, key);
}

//Clear all fonds
$(".time-period-selector").click(function(){
    //Fonds detail page graphs
    let detailCharts = document.getElementsByClassName('chart-canvas-wertentwicklung');
    let clickedElement = $(this).attr('data-graph');

    for (const [key, value] of Object.entries(detailCharts)) {
        loadCharts(value, key, clickedElement);
    }
});

//Fonds comparison page graphs
let detailChartsComparison = document.getElementsByClassName('chart-canvas-comparison');

for (const [key, value] of Object.entries(detailChartsComparison)) {
    loadComparisonCharts(value, key);
}

function loadComparisonCharts(item, index, clickedElement = null) {

    let jsonGraphData = JSON.parse(item.getAttribute('data-graph')),
        graphDataOne = [],
        graphDataTwo = [],
        graphDataThree = [],
        dataArray = [],
        labelOne = '',
        labelTwo = '',
        labelThree = '',
        mainColorScheme = item.getAttribute('data-main-color-theme');

    // Populating the two data arrays from the API data
    // The graph is meant to display two graphs all time
    if (jsonGraphData.length >= 1) {
        for(let i=0; i<jsonGraphData[0]['ts'].length; i++){
            labelOne = jsonGraphData[0]['meta']['name'];
            graphDataOne.push({
                x: new Date( jsonGraphData[0]['ts'][i][0] ),
                y: jsonGraphData[0]['ts'][i][1]
            });
        }
        dataArray.push(
            {
                label: labelOne,
                data: graphDataOne,
                borderColor: mainColorScheme,
                fill: false,
                borderWidth: '1',
                lineTension: '0',
                pointRadius: '0',
            }
        );
    }

    if (jsonGraphData.length >= 2) {
        for(let i=0; i<jsonGraphData[1]['ts'].length; i++){
            labelTwo = jsonGraphData[1]['meta']['name'];
            graphDataTwo.push({
                x: new Date( jsonGraphData[1]['ts'][i][0] ),
                y: jsonGraphData[1]['ts'][i][1]
            });
        }
        dataArray.push(
            {
                label: labelTwo,
                data: graphDataTwo,
                borderColor: '#dcdadb',
                fill: false,
                borderWidth: '1',
                lineTension: '0',
                pointRadius: '0',
            }
        );
    }

    if (jsonGraphData.length == 3) {
        for(let i=0; i<jsonGraphData[2]['ts'].length; i++){
            labelThree = jsonGraphData[2]['meta']['name'];
            graphDataThree.push({
                x: new Date( jsonGraphData[2]['ts'][i][0] ),
                y: jsonGraphData[2]['ts'][i][1]
            });
        }
        dataArray.push(
            {
                label: labelThree,
                data: graphDataThree,
                borderColor: '#707070',
                fill: false,
                borderWidth: '1',
                lineTension: '0',
                pointRadius: '0',
            }
        );
    }

    new Chart(item.getContext('2d'), {
        type: 'line',
        data: {
            datasets: dataArray
        },
        options: {
            scales: {
                yAxes: [{
                    display: false,
                    gridLines: {
                        display: false
                    }
                }],
                xAxes: [{
                    type: 'time',
                    distribution: 'series',
                    gridLines: {
                        drawOnChartArea: false
                    },
                    ticks: {
                        autoSkip: true,
                        autoSkipPadding: 9999,
                        maxRotation: 0,
                    }
                }],
            }
        }
    });
}

//Fonds detail page PIE graphs
//Sample chart configuration
let pieCharts = document.getElementsByClassName('pie-chart-canvas');

for (const [key, value] of Object.entries(pieCharts)) {
    loadPieCharts(value, key);
}

function loadPieCharts(item, index) {

    let jsonGraphData = JSON.parse(item.getAttribute('data-portfolio')),
        chartTrigger = item.getAttribute('data-charttrigger'),
        dataArray = jsonGraphData['breakdowns'][chartTrigger],
        graphData = [],
        bgColorData = [],
        labelsData = [],
        hue = '';

    if (Number.isInteger(dataArray['name'].length)) {
        for(let i=0; i<dataArray['name'].length; i++){
            hue = 'hsla(' + (Math.random() * 360) + ', 55%, 50%, 1)';
            labelsData.push(dataArray['name'][i]['val']);
            graphData.push(dataArray['name'][i]['attr-percent']);
            bgColorData.push(hue);
        }
    } else {
        hue = 'hsla(' + (Math.random() * 360) + ', 55%, 50%, 1)';
        labelsData.push(dataArray['name']['val']);
        graphData.push(dataArray['name']['attr-percent']);
        bgColorData.push(hue);
    }

    new Chart(item.getContext('2d'), {
        type: 'pie',
        data: {
            datasets: [
                {
                    label: 'PRIMA - Global Challenges A',
                    data: graphData,
                    backgroundColor: bgColorData,
                },
            ],
            labels: labelsData
        },
    });
}

// Funds compare
$(".comparison #comparison-trigger").click(function(){
    let currentFund = $(this).attr('data-fundvalue');
    $("#comparison-form #current-fund").attr('value',currentFund);
});

// Sorting fundslist on listing page
$('#sort-fundlist').change(function() {
    let targetUrl = $( "#sort-fundlist option:selected" ).attr('data-url');
    window.location.href = targetUrl;
});

$( document ).ready(function() {
    if($('.particularities .bottom-border-row-heading').next().length == 0) {
        $('.particularities').hide();
    }
    updateISINValues();
});

//Open/close discount popup
$(".discount-opener").click(function(){
    $(".rabat-dropdown").toggleClass("hidden");
    $(this).toggleClass("opened");
});

$("#auto-suggest-name").on("input", function(){
    if ($(this).val().length >= 2) {
        let pagetype = 'type=827282',
            search = 'tx_wvfundsfinder_fundsfilter[search]=' + $(this).val();

        let request = $.ajax({
            url: '/?' + pagetype + '&' + search,
            dataType: 'html'
        });

        request.done(function( result ) {
            let dataList = JSON.parse(result);

            if (dataList != null) {
                let len = dataList.length;
                $("#searchResult").empty();
                if (len > 0) {
                    $(".auto-suggest-wrapper").css('height', '300px');
                    for( let i = 0; i<len; i++){
                        var suggestion = dataList[i];
                        $("#searchResult").append("<li value='"+suggestion+"'>"+suggestion+"</li>");
                    }
                    // binding click event to li
                    $("#searchResult li").bind("click",function(){
                        setText(this);
                    });
                } else {
                    $(".auto-suggest-wrapper").css('height', '0');
                }
            } else {
                $("#searchResult").empty();
                $(".auto-suggest-wrapper").css('height', '0');
            }
        });

        request.fail(function( jqXHR, textStatus ) {
            console.log( "Request failed: " + textStatus );
        });
    } else {
        $('#searchResult').empty();
        $(".auto-suggest-wrapper").css('height', '0');
    }

});

$('body').click(function(e) {
    if ($('#searchResult').length ) {
        $('#searchResult').empty();
        $(".auto-suggest-wrapper").css('height', '0');
    }
});

function setText(element){
    let value = $(element).text();
    $("#auto-suggest-name").val(value);
    $("#searchResult").empty();
}

function renderComparisonItems(localStorageId, fundId, fundTitle, iconPath){
    $(`#${localStorageId}`).val(fundId);
    $(".selected-funds .header").after(
        `<div class='selected-fund' data-id='${fundId}' data-storage-id='${localStorageId}'>
            ${fundTitle}
            <div class='close'  data-id='${fundId}'>
                <img alt='open' src='${iconPath}Images/close-background.svg' width='25' height='25'>
            </div>
        </div>`);
    //Change icon
    $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).toggleClass("hidden");
    $(`.fondsfinder-compare-table table .add[data-id=${fundId}]`).next().toggleClass("hidden");
    $(`.chart-container .add[data-id=${fundId}]`).toggleClass("hidden");
    $(`.chart-container .add[data-id=${fundId}]`).next().toggleClass("hidden");

    $(".selected-fund .close").on('click',function(){
        let removedFundId = $(this).closest(".selected-fund").attr("data-id"),
             fundsId = $(`.fond-ids input[value=${removedFundId}]`).attr("id"),
            storageId = $(this).closest(".selected-fund").attr("data-storage-id");
        localStorage.removeItem(storageId);
        $(`#${storageId}`).val(0);
        $(`.chart-container .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${removedFundId}]`).next().toggleClass("hidden");
        $(`.chart-container .add[data-id=${removedFundId}]`).toggleClass("hidden");
        $(`.chart-container .add[data-id=${removedFundId}]`).next().toggleClass("hidden");

        $(`#action-added-${removedFundId}`).addClass("hidden");
        $(`#action-add-${removedFundId}`).removeClass("hidden");
        $(this).closest(".selected-fund").remove();
        updateISINValues();
    });
}
// Fix regarding the anchor tags and fixed header
// First part checks for a link with anchor specified
$("a[href*='#']").click(function(e) {
    let offset = $(this.hash).offset(),
        headerheight = $('.main-header').height(),
        scrollto = offset.top - parseFloat(headerheight + 50);  // Header height and a bit more
    $('html, body').animate({scrollTop:scrollto}, 700);
});
// Deals the scroll when anchor tags directly accessed without a click event
$(document).ready(function() {
    if(window.location.hash.length > 0) {
        let headerheight = $('.main-header').height();
        window.scrollTo(0, $(window.location.hash).offset().top - parseFloat(headerheight + 50));
    }
});

// Handles the pseudo select field with rating images
// Assigns selected value to TYPO3 form field and handles visual changes
// Open dropdown
$('.rating-drop-opener').click(function(e) {
    e.preventDefault();
    $('.rating-dropdown').toggleClass("show");
});

// Ajax loading of fund categories based on selected fund types
$('#fund-types').on('change', function() {
    if (this.value.length >= 1) {
        var pagetype = 'type=827284',
            search = 'tx_wvfundsfinder_fundsfilter[fundType]=' + this.value;

        var request = $.ajax({
            url: '/?' + pagetype + '&' + search,
            dataType: 'html'
        });

        request.done(function( result ) {
            var dataList = JSON.parse(result);
            var resultString = '<option value="all" selected="selected">Alle...</option>';
            if(dataList.length > 0) {
                $.each( dataList[0], function( key, value ) {
                    resultString += '<option value=" ' + key + '> ' + value + ' </option>';
                });
            }
            $("#fund-categories").empty();
            $("#fund-categories").append(resultString);
        });

        request.fail(function( jqXHR, textStatus ) {
            console.log( "Request failed: " + textStatus );
        });
    }
});

// Manages selection
$('#rating-dropdown-list li').click(function(e) {
    e.preventDefault();
    $('.rating-dropdown').toggleClass("show");
    let selectedSrc = $(this).find('img').attr('src');
    let value = $(this).find('img').attr('value');

    if (selectedSrc) {
        $('.rating-drop-opener li img').removeClass('d-none');
        $('.rating-drop-opener li img').attr('src', selectedSrc);
        $('.rating-drop-opener li span').hide();
        $('#star-rating-field').attr('value', value);
    } else {
        $('.rating-drop-opener li img').addClass('d-none');
        $('.rating-drop-opener li span').show();
        $('#star-rating-field').attr('value', 0);
    }

});

$('#auto-suggest-name').keyup(function (e){
    let searchStr = $(this).val();
    if( searchStr.indexOf(' ') == 0){
        searchStr = $.trim(searchStr);
        $(this).val(searchStr);
    }
});

$(document).on('click', '[rel^="lightbox["]', function(event) {
    event.preventDefault();
    $(this).ekkoLightbox();
});

$('#share-to-media').click(function(e){
    e.preventDefault();
    availModal(e);
});

$('#auto-suggest-name, form#funds-filter-form select').keypress(function (e) {
    if (e.which == 13) {
        e.preventDefault();
        $('form#funds-filter-form').submit();
        return false;
    }
});

$('#add-to-watchlist').click(function(e) {
    e.preventDefault();
    let ajaxUrl = $(this).attr('href'),
        status = null,
        fund = $(this).attr('data-fund');

    if ($(this).hasClass('inactive')) {
        $(this).removeClass('inactive');
        $(this).addClass('active');
        status = 1;
    } else {
        $(this).removeClass('active');
        $(this).addClass('inactive');
        status = 0;
    }
    $.ajax({
        url: ajaxUrl + '&tx_wvfundsfinder_funddetail[status]=' + status + '&tx_wvfundsfinder_funddetail[fund]=' + fund,
        success: function(response){
            result = response.data;
        }
    });
});

$('.contenttable').basictable({
    breakpoint: 768,
});

$('#filter-table').basictable({
    breakpoint: 768,
});

$('#comparison-data-table').basictable({
    breakpoint: 768,
});

function updateISINValues(){
    let pickedFunds = [];
    let fundDetails1 = localStorage.getItem('fund1');
    if(fundDetails1 != null){
        let funInfos1 = JSON.parse(fundDetails1);
        pickedFunds.push(funInfos1.fundId)
    }
    let fundDetails2 = localStorage.getItem('fund2');
    if(fundDetails2 != null ){
        let funInfos2 = JSON.parse(fundDetails2);
        pickedFunds.push(funInfos2.fundId)
    }

    let fundDetails3 = localStorage.getItem('fund3');
    if(fundDetails3 != null){
        let funInfos3 = JSON.parse(fundDetails3);
        pickedFunds.push(funInfos3.fundId)
    }
    $('.selected-funds .submit a').attr('href', '/fondsvergleich/api/' + pickedFunds.join());
}

$(document).ready(function() {
    var flag = 0;
    if ($('.news-category-list').length > 0) {

        $( '.news-category-list li' ).each(function( index ) {
            if ($(this).find('a.active').length !== 0) {
                flag = 1;
            }
        });

        if (flag == 0) {
            $( '.news-category-list li:first-child a:first-child' ).addClass('active');
        }
    }
    makeHeightIdentical();


});

function makeHeightIdentical() {
    $('.news-col-container').each(function(index,value){
        let leftHeaderHeight = $(this).find('.left-box .news-inner-header').height();
        let rightBoxHeight = $(this).find('.right-box .news-inner-header').height();
        let modifiedHeight = Math.max( leftHeaderHeight, rightBoxHeight);

        $(this).find('.left-box .news-inner-header').height(modifiedHeight);
        $(this).find('.right-box .news-inner-header').height(modifiedHeight);
    });
}

let makeHeightIdenticalOnResize = debounce(function() {
    makeHeightIdentical();
}, 250);

function debounce(func, wait, immediate) {
    let timeout;
    return function() {
        let context = this, args = arguments;
        let later = function() {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        let callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
};
$(window).resize( makeHeightIdenticalOnResize );
